import React from 'react';
import './AboutUs.scss';

const AboutUsSection = props => {
  return (
    <div className="row about-us">
      <div className="col-md-8 col-md-offset-2 text-center">
        <h2 className="section-header">Über uns</h2>
        <p>
          <span className="quote">"</span>
          In der Südstadt, mitten unter uns, gibt es Mütter und Väter, die nicht
          in der Lage sind, Weihnachtswünsche ihrer Kinder zu erfüllen, was für
          andere eine Selbstverständlichkeit ist.
        </p>
        <p>
          Kinder, die erleben, dass Wünsche auch in Erfüllung gehen können,
          entwickeln Visionsfähigkeit und Offenheit für Träume, was für ihre
          eigene Persönlichkeitsentwicklung – und für die Zukunft eines
          Gemeinwesens – lebenswichtig ist.
          <span className="quote">"</span>
        </p>
        <p>Pfarrer Hans Mörtter (i.R.)</p>
      </div>
    </div>
  );
};
export default AboutUsSection;



// WEBPACK FOOTER //
// ./src/Containers/HomeElements/AboutUs.js